import jstz from 'jstz';
import { cloneDeep } from 'lodash';
import { equalArrays } from '@fullstory/searchiecache';
import { ComputePageFlowRequest } from '@fullstory/proto/fs/services/alexa';
import { TimeRange } from '@fullstory/proto/fs/api/segment';
import { SegmentDetail } from '@fullstory/proto/fs/services/dx-objects';
import { PageFlow, PageFlowComputation } from '@fullstory/proto/fs/api/metrics/pagemetrics';
import { updateSegmentTimeRange } from '../../utils';
import { PageFlowRequestBody } from './types';

export const pageFlowSimilarData = (
  oldData: PageFlow | null,
  newData: PageFlow | null,
): boolean => {
  if (!oldData || !newData) return false;
  return (
    equalArrays(oldData.incomingEdges, newData.incomingEdges) &&
    equalArrays(oldData.outgoingEdges, newData.outgoingEdges)
  );
};

export const pagesRequestBodyToComputePageFlowRequest = (
  body: PageFlowRequestBody,
): ComputePageFlowRequest => ({
  orgId: body.orgId,
  computation: body.computation,
  now: null, // current time is implied
  timezone: jstz.determine().name(),
  cacheOptions: body.cacheOptions ?? null,
  sampleOptions: body.sampleOptions ?? null,
});

/**
 * Builds the request for the ComputePageFlow API
 */
export const buildPageFlowComputation = (
  pageDefId: number,
  timeRange: TimeRange,
  segment: SegmentDetail,
  numPages: number,
): PageFlowComputation => {
  const segmentDefinition = cloneDeep(segment.segment!.segment!.segmentDefinition!);
  const updatedSegmentDefinition = updateSegmentTimeRange(segmentDefinition, timeRange);
  return {
    pageDefId,
    numPages,
    timeRange,
    collapseRepeated: false,
    segmentDefinitions: updatedSegmentDefinition ? [updatedSegmentDefinition] : [],
    matchingBehaviors: [],
  };
};
